import Vue from 'vue'
import toast from '../../services/toast'

export default {
  state: {
    // actions is an ordered list of actions
    subscribable: {
      startdate: null,
      sub_start_time: null,
      deadline: null,
      sub_deadline_time: null,
      unsubscription_deadline: null,
      sub_unsubscription_deadline_time: null,
      with_unsubscription: false,
      capacity: null,
      subscribable_groups: null,
    },
    exams: {},
    exam_name: '',
    exam_date: null,
    order: [],
    capacities: {},
  },
  mutations: {
    CLEAR_EXAMS (state) {
      state.exams = {}
    },
    ADD_EXAM (state, exam) {
      Vue.set(state.exams, exam.id, exam)
    },
    UPDATE_EXAM_SUBSCRIBABLE (state, { name, value }) {
      state.subscribable[name] = value
    },
    UPDATE_EXAM_NAME (state, name) {
      state.exam_name = name
    },
    UPDATE_EXAM_DATE (state, date) {
      state.exam_date = date
    },
    CHANGE_ORDER (state, order) {
      state.order = order
    },
    CHANGE_CAPACITY (state, { examId, value }) {
      Vue.set(state.capacities, examId, value)
    },
    UNSET_CAPACITY (state, { examId }) {
      Vue.delete(state.capacities, examId)
    },
  },
  actions: {
    get_exam_events ({ commit, state }, examName) {
      commit('UPDATE_EXAM_NAME', examName)
      commit('CLEAR_EXAMS')
      return axios.post(`/exam/subscribables/create-api`, { exam_name: examName, date: state.exam_date, edit: true }).then(data => {
        let exams = _.orderBy(data.data.data, 'attributes.classroom_name')
        let order = []
        exams.forEach(exam => {
          commit('ADD_EXAM', exam)
          commit('CHANGE_CAPACITY', { examId: exam.id, value: Number(exam.attributes.classroom_capacity) })
          order.push(exam.id)
        })
        commit('CHANGE_ORDER', order)
      })
    },
    update_exam_subscribable ({ commit, state }, { name, value }) {
      return commit('UPDATE_EXAM_SUBSCRIBABLE', { name: name, value: value })
    },
    update_exam_date ({ commit, state }, date) {
      return commit('UPDATE_EXAM_DATE', date)
    },
    change_order ({ commit, state }, orderedExams) {
      let order = []
      Object.values(orderedExams).forEach(exam => {
        order.push(exam.id)
      })
      commit('CHANGE_ORDER', order)
    },
    change_order_by_array ({ commit, state }, orderArray) {
      commit('CHANGE_ORDER', orderArray)
    },
    change_capacity ({ commit, state }, { examId, capacity }) {
      commit('CHANGE_CAPACITY', { examId: examId, value: Number(capacity) })
    },
    unset_capacity ({ commit, state }, { examId }) {
      commit('UNSET_CAPACITY', { examId: examId })
    },
  },
  getters: {},
}
